<template>
  <AppShell v-if="usesShell" :global-props="globalProps" :nav-items="globalProps.navItems || []">
    <component :is="currentPage" :page-props="pageProps" />
  </AppShell>
  <component :is="currentPage" v-else :page-props="pageProps" />

  <FlashContainer />
</template>

<script setup>
import { computed } from "vue";
import AppShell from "./components/AppShell.vue";
import FlashContainer from "./components/common/FlashContainer.vue";
import ReportsIndexPage from "./views/ReportsIndexView.vue";
import ReportNewPage from "./views/ReportNewView.vue";
import ReportShowPage from "./views/ReportShowView.vue";
import OrganisationShowPage from "./views/OrganisationShowView.vue";
import OrganisationEditPage from "./views/OrganisationEditView.vue";
import UserInvitePage from "./views/UserInviteView.vue";
import JobsIndexPage from "./views/JobsIndexView.vue";
import DeviseFormPage from "./views/DeviseFormView.vue";
import DeviseRegistrationEditPage from "./views/DeviseRegistrationEditView.vue";

const props = defineProps({
  page: {
    type: String,
    required: true,
  },
  globalProps: {
    type: Object,
    required: true,
  },
  pageProps: {
    type: Object,
    required: true,
  },
});

const pages = {
  "reporting-reports-index": ReportsIndexPage,
  "reporting-reports-new": ReportNewPage,
  "reporting-reports-show": ReportShowPage,
  "organisations-show": OrganisationShowPage,
  "organisations-edit": OrganisationEditPage,
  "users-new": UserInvitePage,
  "jobs-index": JobsIndexPage,
  "devise-sessions-new": DeviseFormPage,
  "devise-passwords-new": DeviseFormPage,
  "devise-passwords-edit": DeviseFormPage,
  "users-registrations-new": DeviseFormPage,
  "users-registrations-edit": DeviseRegistrationEditPage,
  "devise-confirmations-new": DeviseFormPage,
  "devise-unlocks-new": DeviseFormPage,
};

const currentPage = computed(() => pages[props.page] || ReportsIndexPage);
const usesShell = computed(() => {
  return !(props.page.startsWith("devise-") || props.page.startsWith("users-registrations-"));
});
</script>
